<div
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  class="connect-bg connect-channel"
>
  <h2>{{ titleText }}</h2>
  <h3>{{ step1TitleText }}</h3>
  <p>
    {{ step1IntroText }}
    <a href="https://www.facebook.com/pages/create/" target="_blank">{{
      step1LinkText
    }}</a>
    {{ step1OutroText }}
  </p>
  <h3>{{ step2TitleText }}</h3>
  @if (loginStatus?.status === 'connected' && !loadingUser) {
    <p fxLayout="row" fxFlexAlign="start center"> {{ loggedInAsText }} </p>
  }
  @if (loginStatus?.status === 'connected' && !loadingUser) {
    <p>
      <strong class="fb-name"
        >{{ curUser?.firstName }} {{ curUser?.lastName }}</strong
      >
      <span
        class="fb-logout"
        (click)="logoutFb()"
        fxFlex="none"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <span>{{ logoutText }}</span>
        <mat-icon>close</mat-icon>
      </span>
    </p>
  }
  @if (loadingUser) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }
  @if (!curUser && !loadingUser) {
    <button
      mat-raised-button
      fxFlex="none"
      type="submit"
      (click)="connectAccount()"
    >
      {{ connectAccountText }}
    </button>
  }

  <h3 [ngClass]="{ disabled: !curUser }">{{ step3TitleText }}</h3>
  @if (feedback) {
    <p class="text-feedback"> {{ problemGettingPagesText }} </p>
  }
  @if (facebookPages && !facebookPages?.length) {
    <p>
      {{ noPagesText }}
      <span class="refresh-fb-pages" (click)="connectAccount()"
        >{{ refreshText }}<mat-icon>refresh</mat-icon></span
      >
    </p>
  }
  @if (facebookPages && facebookPages?.length) {
    <p> {{ messagesSentText }} </p>
  }
  @if (loadingPages) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }
  @if (facebookPages && !loadingPages) {
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="center center"
      class="pages-select"
    >
      <mat-select
        fxFlex="none"
        [(ngModel)]="selectedFacebookPage"
        floatPlaceholder="never"
      >
        @for (page of facebookPages; track page) {
          <mat-option [value]="page">
            <img width="20" [src]="page.pic" /> <span>{{ page.name }}</span>
          </mat-option>
        }
      </mat-select>
      @if (facebookPages?.length) {
        <span
          class="refresh-fb-pages"
          mat-icon-button
          (click)="refreshPages()"
          fxFlex="none"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <span>{{ refreshText }}</span>
          <mat-icon>refresh</mat-icon>
        </span>
      }
    </div>
  }
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!(facebookPages && selectedFacebookPage)"
    (click)="connectPage()"
  >
    {{ connectPageText }}
  </button>
</div>
